import { useRouter } from 'next/router'

import styled from '@emotion/styled'

export default function Custom404() {
  const router = useRouter()

  return (
    <Container>
      <div>
        <Status>404</Status>
        <Message>Not Found</Message>
        <GoToHome onClick={() => router.push('/')}>Go To Home</GoToHome>
      </div>
    </Container>
  )
}

const Container = styled.main`
  width: 100%;
  height: 100vh;
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Status = styled.h1`
  font-size: 100px;
  font-weight: 200;

  background: linear-gradient(
    135deg,
    rgba(255, 74, 82, 1) 0%,
    rgba(255, 115, 61, 0.3) 50%,
    rgba(255, 74, 82, 1) 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
`

const Message = styled.p`
  font-size: 20px;
  text-align: center;

  background: linear-gradient(
    135deg,
    rgba(255, 74, 82, 1) 0%,
    rgba(255, 115, 61, 0.3) 50%,
    rgba(255, 74, 82, 1) 100%
  );
  background-clip: text;
  -webkit-background-clip: text;
  color: transparent;
`

const GoToHome = styled(Message)`
  font-size: 12px;
  margin-top: 50px;
  text-decoration: underline;
  cursor: pointer;
`
